<main
  class="other-topics-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <section class="full-width">
    <span class="line"></span>
    <span class="fixed-space-16" aria-hidden="true"></span>

    @if (lang !== 'AR') {
      <h2>Other Topics</h2>
    } @else {
      <h2>موضوعات أخرى</h2>
    }
    <span class="fixed-space-8" aria-hidden="true"></span>
    <div class="grid">
      @if (routerStep() !== 'PAYMENT_METHODS') {
        <a
          class="grid-item popsy-card"
          [routerLink]="getInfoFragment('payment-methods')"
          [queryParams]="queryParams$ | async">
          @if (lang !== 'AR') {
            <h2>Payment Methods</h2>
          } @else {
            <h2>طرق الدفع</h2>
          }
          <span class="read-more">{{ t('label_read_more') }}</span>
        </a>
      }

      @if (routerStep() !== 'SHIPPING_AND_DELIVERY') {
        <a
          class="grid-item popsy-card"
          [routerLink]="getInfoFragment('shipping-and-delivery')"
          [queryParams]="queryParams$ | async">
          @if (lang !== 'AR') {
            <h2>Shipping And Delivery</h2>
          } @else {
            <h2>الشحن والتسليم</h2>
          }
          <span class="read-more">{{ t('label_read_more') }}</span>
        </a>
      }

      @if (routerStep() !== 'WARRANTY_AND_REFUNDS') {
        <a
          class="grid-item popsy-card"
          [routerLink]="getInfoFragment('warranty-and-refunds')"
          [queryParams]="queryParams$ | async">
          @if (lang !== 'AR') {
            <h2>Warranty and Refunds</h2>
          } @else {
            <h2>الضمان وسياسة الإرجاع</h2>
          }
          <span class="read-more">{{ t('label_read_more') }}</span>
        </a>
      }
    </div>

    <span class="fixed-space-32" aria-hidden="true"></span>

    <div>
      @if (lang !== 'AR') {
        <span
          class="popsy-button-option faq-button"
          [routerLink]="getInfoFragment('faq')"
          [queryParams]="queryParams$ | async"
          >Return to FAQ</span
        >
      } @else {
        <span
          class="popsy-button-option faq-button"
          [routerLink]="getInfoFragment('faq')"
          [queryParams]="queryParams$ | async">
          العودة إلى قائمة الأسئلة والأجوبة
        </span>
      }
      <span class="fixed-space-12" aria-hidden="true"></span>
    </div>
  </section>
</main>
